export class SfgeHelper {

    // ==========================
    // ETÀ
    // ==========================

    static getEtaDescription(value: number): string {

        switch (value) {

            case 0:
                return '< 75 anni';

            case 1:
                return '75 - 85 anni';

            case 2:
                return '> 85 anni';

            default:
                return '-';
        }
    }

    // ==========================
    // FORMAZIONE
    // ==========================

    static getFormazioneDescription(value: number): string {

        switch (value) {

            case 1:
                return 'Elementari / Medie';

            case 0:
                return 'Diploma / Laurea';

            default:
                return '-';
        }
    }

    // ==========================
    // CONVIVENTI
    // ==========================

    static getConviventiDescription(value: number, tipoConvivente: number | null = null): string {

        switch (value) {

            case 1:
                return 'Nessuno';

            case -1:
                return 'Coniuge';

            case 0:
                return tipoConvivente === 1 ? 'Altri' : 'Assistente a pagamento';

            default:
                return '-';
        }
    }

    static getEtaConiugeDescription(value: number): string {

        switch (value) {

            case -1:
                return '< 75 anni';

            case 0:
                return '75 - 85 anni';

            case 1:
                return '> 85 anni';

            default:
                return '-';
        }
    }

    // ==========================
    // RETE SOCIALE
    // ==========================

    static getAiutoDescription(value: number): string {

        switch (value) {

            case -1:
                return 'Sì, sempre';

            case 0:
                return 'Sì, occasionalmente';

            case 1:
                return 'No';

            default:
                return '-';
        }
    }

    static getAttivitaDescription(value: number): string {

        switch (value) {

            case -1:
                return 'Sì';

            case 0:
                return 'No';

            default:
                return '-';
        }
    }

    static getServiziDescription(value: number): string {

        switch (value) {

            case -1:
                return 'Sì';

            case 0:
                return 'No';

            default:
                return '-';
        }
    }

    // ==========================
    // ECONOMIA
    // ==========================

    static getSituazioneEconomicaDescription(
        value: number
    ): string {

        switch (value) {

            case -1:
                return 'Arriva a fine mese';

            case 0:
                return 'Con fatica';

            case 1:
                return 'Non arriva';

            default:
                return '-';
        }
    }

    static getProblemiEconomiciDescription(
        value: number
    ): string {

        switch (value) {

            case 2:
                return 'Cibo, medicine, bollette o assistenza';

            case 1:
                return 'Aiuto domestico';

            default:
                return '-';
        }
    }

    // ==========================
    // PSICOLOGICO
    // ==========================

    static getEnergiaDescription(value: number): string {

        switch (value) {

            case 0:
                return 'Normale';

            case 2:
                return 'Ipoattivo / Iperattivo';

            default:
                return '-';
        }
    }

    // ==========================
    // STATO FUNZIONALE
    // ==========================

    static getBagnoDescription(value: number): string {

        switch (value) {

            case 0:
                return 'Autonomo';

            case 2:
                return 'Non autonomo';

            default:
                return '-';
        }
    }

    static getEsceCasaDescription(value: number): string {

        switch (value) {

            case 0:
                return 'Sì';

            case 2:
                return 'No';

            default:
                return '-';
        }
    }

    static getAllettatoDescription(value: number): string {

        switch (value) {

            case 0:
                return 'No';

            case 4:
                return 'Sì';

            default:
                return '-';
        }
    }

    static getConfusoDescription(value: number): string {

        switch (value) {

            case 0:
                return 'No';

            case 8:
                return 'Sì';

            default:
                return '-';
        }
    }

    // ==========================
    // FARMACI
    // ==========================

    static getFarmaciDescription(value: number): string {

        switch (value) {

            case 0:
                return '0 - 3 farmaci';

            case 1:
                return '> 3 farmaci';

            default:
                return '-';
        }
    }

    // ==========================
    // CADUTE
    // ==========================

    static getCaduteDescription(value: number): string {

        switch (value) {

            case 0:
                return 'Nessuna';

            case 1:
                return 'Una volta';

            case 2:
                return 'Più di una volta';

            default:
                return '-';
        }
    }

    // ==========================
    // RICOVERI
    // ==========================

    static getRicoveriDescription(value: number): string {

        switch (value) {

            case 0:
                return 'Nessuno';

            case 1:
                return 'Una volta';

            case 2:
                return 'Più di una volta';

            default:
                return '-';
        }
    }

    // ==========================
    // CLASSE RISCHIO
    // ==========================

    static getClasseRischioColor(
        classe: string
    ): string {

        switch (classe) {

            case 'Robusto':
                return 'bg-success';

            case 'Pre-Fragile':
                return 'bg-warning text-dark';

            case 'Pre-fragile':
                return 'bg-warning text-dark';

            case 'Fragile':
                return 'bg-danger';

            case 'Molto Fragile':
                return 'bg-danger';

            default:
                return 'bg-secondary';
        }
    }

    // ==========================
    // CLASSE RISCHIO
    // ==========================
    static getInterpretazione(
        classeRischio: string
    ): string {

        switch (classeRischio) {

            case 'Robusto':
                return 'Nessuna vulnerabilità significativa rilevata.';

            case 'Pre-Fragile':
                return 'Presenti primi segni di vulnerabilità.';

            case 'Pre-fragile':
                return 'Presenti primi segni di vulnerabilità.';

            case 'Fragile':
                return 'Necessita di monitoraggio e supporto socio-sanitario.';

            case 'Molto Fragile':
                return 'Richiede presa in carico multidisciplinare prioritaria.';

            default:
                return '-';
        }
    }
}